import storage from 'store2'

/** 统一 IM 通知/快捷键等本地设置的 storage key */
export function getImSettingsKey() {
  const uid = storage.get('userId') || storage.get('ImAcount') || ''
  return uid + 'seting'
}

export function getImSettings() {
  const key = getImSettingsKey()
  if (storage.has(key)) {
    try {
      return JSON.parse(storage.get(key))
    } catch (e) {
      return null
    }
  }
  const legacyKey = (storage.get('ImAcount') || '') + 'seting'
  if (legacyKey !== 'seting' && storage.has(legacyKey)) {
    try {
      const obj = JSON.parse(storage.get(legacyKey))
      storage.set(key, JSON.stringify(obj))
      return obj
    } catch (e) {
      return null
    }
  }
  return null
}

export function setImSettings(obj) {
  storage.set(getImSettingsKey(), JSON.stringify(obj))
  const imAccount = storage.get('ImAcount')
  if (imAccount) {
    storage.set(imAccount + 'seting', JSON.stringify(obj))
  }
}
